import LocalizedStrings from 'react-localization'

import de from './de'
import en from './en'

export default new LocalizedStrings({
  en,
  de,
})
